import { render } from "./List.vue?vue&type=template&id=1c12e9b9"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
script.render = render

export default script